import React from "react";

function LeftLine() {
  return (
    <div className="leftLineWrap">Beyond ICT, Creative value and trust</div>
  );
}

export default LeftLine;
